/* eslint-disable default-case */
/* eslint-disable consistent-return */
import * as TimePickerHelpers from 'web-app/react/components/form-elements/timepicker/helpers';

import * as Types from './types';

export const toAPI = (formData: Types.FormData): Types.BaseAPIData => {
    switch (formData.active) {
        case Types.ActiveState.enabled:
            return {
                active: true,
                from: TimePickerHelpers.timeValueToString(formData.from),
                to: TimePickerHelpers.timeValueToString(formData.to),
                duringWeekends: !formData.disableWeekends,
            };
        case Types.ActiveState.disabled:
            if (formData.disableWeekends) {
                /*
                    In the UI you can effectively "disable" this feature by allowing push notifications to come all day
                    but still disallow them on weekends with back-end wise sets this feature to active
                */
                return {
                    active: true,
                    from: '00:00:00',
                    to: '23:59:59',
                    duringWeekends: false,
                };
            }
            return {
                active: false,
                from: '00:00:00',
                to: '23:59:59',
                duringWeekends: true,
            };
    }
};

export const fromAPI = (apiData: Types.APIData): Types.FormData => {
    if (apiData === null) {
        return {
            active: Types.ActiveState.disabled,
            from: null,
            to: null,
            disableWeekends: false,
        };
    }
    const active = apiDataToActiveState(apiData);
    return {
        active,
        from: active === Types.ActiveState.enabled ? TimePickerHelpers.timeStringToValue(apiData.from) : null,
        to: active === Types.ActiveState.enabled ? TimePickerHelpers.timeStringToValue(apiData.to) : null,
        disableWeekends: !apiData.duringWeekends,
    };
};

export const apiDataToActiveState = (apiData: Types.BaseAPIData): Types.ActiveState => {
    if (
        apiData.active &&
        !apiData.duringWeekends &&
        ((!apiData.from && !apiData.to) || (apiData.from === '00:00:00' && apiData.to === '23:59:59'))
    ) {
        return Types.ActiveState.disabled;
    }
    return apiData.active ? Types.ActiveState.enabled : Types.ActiveState.disabled;
};
